import { eulerConfigs, eulerVaults } from '@1delta/data-sdk'
import { vaultLensAbi } from '../../../abis/euler/vaultLens'
import { ENABLED_EULER_V2_CHAINS } from '../../../utils'

export const buildEulerV2LenderReserveCall = (
  chainId: string,
  lender: string,
) => {
  if (!ENABLED_EULER_V2_CHAINS.includes(chainId)) return []
  const config = eulerConfigs()?.[lender]?.[chainId]
  const vaults = eulerVaults()?.[lender]?.[chainId] ?? []

  if (!config || vaults.length === 0) return []

  return vaults.map((entry) => ({
    address: config.vaultLens,
    name: 'getVaultInfoFull',
    params: [entry.vault],
    abi: vaultLensAbi,
  }))
}
